import {useLocation} from "react-router";

export function useQuery(): any {
	return new URLSearchParams(useLocation().search);
}
